function initializeProductPrices(root = document) {
  root.querySelectorAll('[data-product-section]').forEach(section => {
    const select = section.querySelector('select[name="id"]');
    const price = section.querySelector('[data-variant-price]');
    if (!select || !price || select.dataset.bound === 'true') return;
    const update = () => { const option = select.selectedOptions[0]; if (option) price.textContent = option.dataset.price; };
    select.addEventListener('change', update); select.dataset.bound = 'true'; update();
  });
}
initializeProductPrices();
document.addEventListener('shopify:section:load', event => initializeProductPrices(event.target));
